define(function(require){

 	'use strict';

 	var Marionette = require('marionette');
 	var template   = require('text!modals/_base/template/body.tpl').default;


 	return Marionette.ItemView.extend({
 		template : template,
 		initialize : function(model){
            this.model = model;
 		}
 	});

 });
